import {createContext, useContext, useState} from 'react'

const Context = createContext()

export const useGlobalStates = () => {
    const context = useContext(Context)
    if (!context) {
        throw new Error('This context hook must be used within its provider')
    }
    return context
}

export const GlobalStatesProvider = ({children}) => {
    const [loading, setLoading] = useState(false)
    const [messageBox, setMessageBox] = useState(null)
    const [mobileSidebar, setMobileSidebar] = useState(false)
    const [logout, setLogout] = useState(false)
    const [branchId, setBranchId] = useState(null)
    const [dashboardDate, setDashboardDate] = useState(new Date())
    const [dashboardRefresh, setDashboardRefresh] = useState(new Date())

    const value = {
        loading,
        setLoading,
        messageBox,
        setMessageBox,
        mobileSidebar,
        setMobileSidebar,
        logout,
        setLogout,
        branchId,
        setBranchId,
        dashboardDate,
        setDashboardDate,
        dashboardRefresh,
        setDashboardRefresh,
    }

    return <Context.Provider value={value}>{children}</Context.Provider>
}
